import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.Save.IRequest;
type Query = Api.Core.Contract.Save.IQuery;
type Response = Api.Core.Contract.Save.IResponse;
type Headers = Api.Core.Contract.Save.IHeaders;
const url = '/api/Sales/Contract/Unrestricted';
export default async function contractSaveUnrestrictedApi(body?: Request, query?: Query): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, null, query),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
